import { OrientationStore } from './store';

export const useOrientationStore = OrientationStore.getInstance;
